import 'regenerator-runtime/runtime';
import 'core-js';
import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import axios from 'axios'
import x2js from 'x2js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI, axios, x2js)
Vue.config.productionTip = false
Vue.prototype.x2js = new x2js()

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
